import React from "react";
import { ChevronRight } from "lucide-react";
import { subtreeIds } from "../../lib/categoryTree";

export const countIn = (node, byCat) => subtreeIds(node).reduce((n, id) => n + (byCat[id]?.length || 0), 0);

function renderSection(node, level, { byCat, open, toggle, renderGrid }) {
  const total = countIn(node, byCat);
  if (!total) return null;
  const isOpen = open[node.id] !== false;
  const own = byCat[node.id] || [];
  const kids = node.children.filter((k) => countIn(k, byCat) > 0);
  return (
    <section key={node.id} className={level ? "ml-4 pl-4 border-l border-border/70" : ""} data-testid={`prod-group-${node.id}`}>
      <button
        type="button"
        onClick={() => toggle(node.id)}
        className="w-full flex items-baseline justify-between border-b border-border pb-2 mb-4 text-left group"
        aria-expanded={isOpen}
        data-testid={`prod-group-toggle-${node.id}`}
      >
        <span className="flex items-center gap-2">
          <ChevronRight className={`h-4 w-4 text-muted-foreground transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`} strokeWidth={1.5} />
          <span className={`font-display tracking-tight group-hover:text-accent transition-colors ${level ? "text-lg" : "text-2xl"}`}>{node.name}</span>
        </span>
        <span className="text-xs text-muted-foreground italic">{total} title{total === 1 ? "" : "s"}</span>
      </button>
      {isOpen && (
        <div className="space-y-8 mb-8">
          {own.length > 0 && renderGrid(own)}
          {kids.map((k) => renderSection(k, level + 1, { byCat, open, toggle, renderGrid }))}
        </div>
      )}
    </section>
  );
}

export const CategorySection = ({ node, level, ...rest }) => renderSection(node, level, rest);
